import { createGlobalStyle } from "styled-components";
import NeutralFaceBold from "../assets/fonts/NeutralFace-Bold.otf";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'NeutralFace';
    src: url(${NeutralFaceBold}) format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  :root {
    --accent: ${({ theme }) => theme.accent};
    --accent-rgb: ${({ theme }) => theme.accentRgb};
  }

  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  ::selection {
    background: ${({ theme }) => theme.accent};
    color: #000;
  }


  button:focus {
  outline: none;
  }

  html {
    scroll-behavior: smooth;
    /* Reserve scrollbar space so content doesn't shift sideways when a page
       grows past the viewport for the first time. */
    scrollbar-gutter: stable;
  }

  body {
    background: ${({ theme }) => theme.bg};
    color: ${({ theme }) => theme.textPrimary};
    font-family: ${({ theme }) => theme.font};
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
  }

  ::-webkit-scrollbar {
    width: 0px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0;
  }

  @keyframes confettiFall {
    0% {
      opacity: 1;
      transform: translateY(0) rotate(0deg) scale(1);
    }
    100% {
      opacity: 0;
      transform: translateY(100vh) rotate(720deg) scale(0.3);
    }
  }

  .confetti-piece {
    position: fixed;
    width: 10px;
    height: 10px;
    z-index: 99999;
    pointer-events: none;
    animation: confettiFall 1.5s ease-out forwards;
  }
`;

export default GlobalStyles;
